const container = document.getElementById('toast-container');
const template = container.querySelector('template');

export function toast(message, type = 'info', visibleFor = 5) {
    const clone = template.content.cloneNode(true);
    const toast = clone.firstElementChild;
    toast.classList.add(type);
    toast.style.setProperty('--visible-for', visibleFor + 's');

    const messageContainer = toast.querySelector('.message span.text');
    messageContainer.innerText = message;

    container.appendChild(toast);
    container.hidePopover();
    container.showPopover();

    setTimeout(() => {
        toast.classList.add('show');
    }, 10);

    setTimeout(() => {
        dismissToast(toast);
    }, visibleFor * 1000);

    toast.addEventListener('click', () => dismissToast(toast));
}

function dismissToast(toast) {
    toast.classList.remove('show');
    toast.classList.add('hide');

    toast.addEventListener('transitionend', () => {
        toast.remove();
    });
}